import { Divider, HStack, VStack } from '@cbhq/cds-web/layout';
import { TextBody, TextTitle3 } from '@cbhq/cds-web/typography';

export function APIKeyTitle() {
  return (
    <>
      <HStack spacingHorizontal={7} spacingTop={5} width="100%" justifyContent="space-between">
        <VStack width="66%" gap={3} spacingBottom={3}>
          <TextTitle3 as="p">Configure your API access</TextTitle3>
          <TextBody as="p" color="foregroundMuted">
            Configure your Secret API Keys, Client API Key, or OAuth access here.
          </TextBody>
        </VStack>
      </HStack>
      <Divider />
    </>
  );
}
